import { PolicyValidator, Policy } from '../policy.interface';

const appPolicy: PolicyValidator = {
    validate: (policy: Policy) => {
        return policy?.isPortalAdmin || (policy?.isPortalUser && policy?.licenseAndScope['tenant_management']?.length > 0);
    }
};

export default appPolicy;
